import { render, staticRenderFns } from "./shop-myaccount.vue?vue&type=template&id=56eb9a8e&"
import script from "./shop-myaccount.vue?vue&type=script&lang=js&"
export * from "./shop-myaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports